import { DAY_WIDTH_DEFAULT, DAY_WIDTH_MAX, DAY_WIDTH_MIN } from "@/components/roadmap/RoadmapGantt";

const STORAGE_KEY = "izanagi.roadmapDayWidth";

/** ロードマップのズーム (1日の幅)。保存値が無い・範囲外・壊れている場合は既定値。 */
export function readStoredRoadmapDayWidth(): number {
	try {
		const value = Number(window.localStorage.getItem(STORAGE_KEY) ?? Number.NaN);
		return Number.isInteger(value) && value >= DAY_WIDTH_MIN && value <= DAY_WIDTH_MAX
			? value
			: DAY_WIDTH_DEFAULT;
	} catch (err: unknown) {
		console.error("ロードマップのズームの読み込みに失敗しました", err);
		return DAY_WIDTH_DEFAULT;
	}
}

export function writeStoredRoadmapDayWidth(dayWidth: number): void {
	try {
		window.localStorage.setItem(STORAGE_KEY, String(dayWidth));
	} catch (err: unknown) {
		// 保存できなくてもズーム操作自体は効く。スライダー操作のたびに通知すると煩いのでログだけ残す。
		console.error("ロードマップのズームの保存に失敗しました", err);
	}
}
